import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#F43662",
      contrastText: "#fff",
    },
    secondary: {
      main: "#32312F",
      contrastText: "#fff",
    },
    background: {
      default: "#f6f3ef",
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: "Montserrat, Arial, sans-serif",
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
